// Whole amounts stay whole; `twoDecimals` shows every other amount to two decimals.
const fractionDigits = (twoDecimals: boolean): Intl.NumberFormatOptions =>
  twoDecimals
    ? { maximumFractionDigits: 2, minimumFractionDigits: 2, trailingZeroDisplay: 'stripIfInteger' }
    : { maximumFractionDigits: 2, minimumFractionDigits: 0 }

export const formatCurrency = ({
  amount,
  currency = 'GBP',
  locale = 'en-GB',
  showCurrencyCode = false,
  twoDecimals = false,
}: {
  amount?: number
  currency?: string
  locale?: string
  showCurrencyCode?: boolean
  /** "1,350.50" rather than "1,350.5"; whole amounts stay "500". */
  twoDecimals?: boolean
}) => {
  if (amount === null || amount === undefined) return ''

  // Convert from cents to standard currency units
  const standardAmount = amount / 100

  if (showCurrencyCode) {
    const formattedAmount = new Intl.NumberFormat(locale, {
      ...fractionDigits(twoDecimals),
      style: 'decimal',
    }).format(standardAmount)

    return `${formattedAmount} ${currency}`
  }

  return new Intl.NumberFormat(locale, {
    ...fractionDigits(twoDecimals),
    currency,
    style: 'currency',
  }).format(standardAmount)
}

export const formatCurrencyOrDash = ({
  amount,
  currency = 'GBP',
  locale = 'en-GB',
  showCurrencyCode = false,
}: {
  amount?: null | number
  currency?: string
  locale?: string
  showCurrencyCode?: boolean
}) => (amount != null ? formatCurrency({ amount, currency, locale, showCurrencyCode }) : '-')
